import base from '@/http/url_base';

export default {
  EMPLOYE: base.API_RH + '/employes',
  GET_REQUIREMENTS: base.API_RH + '/employes/requirements',
  GET_PLANNING: function (id) {
    return base.API_RH + '/employes/' + id + '/planning';
  },
  GET_PLANNING_CALENDAR: function (id) {
    return base.API_RH + '/employes/' + id + '/planning-calendar';
  },
};
